import { SimpleCrypt } from 'ngx-simple-crypt';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/app/services/login.service';
import { Router } from '@angular/router';
import { SwPush } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  simpleCrypt = new SimpleCrypt();
  private storageKey: string = "szHYxd7tz";
  private readonly deviceCookieName = 'deviceId';
  private readonly deviceCookieDomain = 'milvus.com.br';

  constructor(
    private loginService: LoginService,
    private router: Router,
    private swPush: SwPush
  ) { }

  storageItem(name: string, content: any): void {
    let itemExists = this.getStoredItem(name);
    if (itemExists !== null) {
      this.removeStoredItem(name);
    }

    const encryptContent = CryptoJS.AES.encrypt(JSON.stringify(content), this.storageKey);
    window.localStorage.setItem(name, encryptContent);
  }

  storageItemSimple(name: string, content: any): void {
    let itemExists = this.getStoredItemSimple(name);
    if (itemExists) {
      this.removeStoredItem(name);
    }

    const encodeContent = SimpleCrypt.encodeDefault(this.storageKey, content);
    if (name === this.deviceCookieName && this.shouldUseDeviceCookie()) {
      this.setCookie(name, encodeContent, 365, this.deviceCookieDomain);
    } else {
      window.localStorage.setItem(name, encodeContent);
    }
  }

  getStoredItem(name: string): any {
    const encryptedItem = window.localStorage.getItem(name);
    if (encryptedItem !== null) {
      try {
        const decryptedContent = CryptoJS.AES.decrypt(encryptedItem, this.storageKey);
        const decodedContent = JSON.parse(decryptedContent.toString(CryptoJS.enc.Utf8));
        return decodedContent;
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  getStoredItemSimple(name: string): any {
    if (name === this.deviceCookieName && this.shouldUseDeviceCookie()) {
      const cookieValue = this.getCookie(name);
      return cookieValue ? SimpleCrypt.decodeDefault(this.storageKey, cookieValue) : null;
    }

    if (window.localStorage.getItem(name)) {
      return SimpleCrypt.decodeDefault(this.storageKey, window.localStorage.getItem(name));
    }

    return null;
  }

  removeStoredItem(name: string): void {
    if (name === this.deviceCookieName && this.shouldUseDeviceCookie()) {
      this.deleteCookie(name, this.deviceCookieDomain);
    }

    window.localStorage.removeItem(name);
  }

  getStoredItemsByName(name: string) {
    var filtrosStored: {} = this.getStoredItemSimple(name);
    if (filtrosStored !== null) {
      return JSON.parse(JSON.stringify(filtrosStored));
    }
  }

  getDeviceIdForAuth(): any {
    const storedDeviceId = this.getStoredItemSimple(this.deviceCookieName);
    if (storedDeviceId) {
      return storedDeviceId;
    }

    if (this.shouldUseDeviceCookie()) {
      const encodedLocalDeviceId = window.localStorage.getItem(this.deviceCookieName);
      if (encodedLocalDeviceId) {
        this.setCookie(this.deviceCookieName, encodedLocalDeviceId, 365, this.deviceCookieDomain);
        return SimpleCrypt.decodeDefault(this.storageKey, encodedLocalDeviceId);
      }
    }

    return null;
  }

  ensureDeviceIdCookieFromLocalStorage(): void {
    if (!this.shouldUseDeviceCookie()) {
      return;
    }

    const hasCookie = this.getCookie(this.deviceCookieName);
    const encodedLocalDeviceId = window.localStorage.getItem(this.deviceCookieName);

    if (!hasCookie && encodedLocalDeviceId) {
      this.setCookie(this.deviceCookieName, encodedLocalDeviceId, 365, this.deviceCookieDomain);
    }
  }

  setStoredItemsByName(name: string, item: any) {
    if (item) {
      this.storageItemSimple(name, item);
    }
  }

  logoutWithLocalData(noReload?: boolean, sessao_expirada?: string): void {
    this.loginService.logout(this.getUserSession(), this.getToken())
      .subscribe({
        next: (result) => {
          let _tema = localStorage.getItem('theme');
          let _usaFiltroNovo = localStorage.getItem('usa_filtro_novo');

          let _filtroDashboardTicket = this.getStoredItemsByName('listagemDashboardTicket');
          let _filtroDashboardCanaisAtendimento = this.getStoredItemsByName('listagemCanaisAtendimento');
          let _filtroDashboardChat = this.getStoredItemsByName('listagemDashboardChat');
          let _filtroDashboardUsersStatus = this.getStoredItemsByName('listagemDashboardUsersStatus');
          let _filtroDashboardClassificacaoInterna = this.getStoredItemsByName('listagemDashboardClassificacaoInterna');
          let _filtroDashboardClassificacaoTicketCliente = this.getStoredItemsByName('listagemDashboardClassificacaoTicketCliente');
          let _filtroDashboardDashboard = this.getStoredItemsByName('listagemDashboardDashboard');
          let _filtroDashboardInventario = this.getStoredItemsByName('listagemDashboardInventario');
          let _filtroDashboardMesas = this.getStoredItemsByName('listagemDashboardMesas');
          let _filtroDashboardMonitoramentoLink = this.getStoredItemsByName('listagemDashBoardMonitoramentoLink');
          let _filtroDashboardPrincipal = this.getStoredItemsByName('listagemDashboardPrincipal');
          let _filtroDashboardSla = this.getStoredItemsByName('listagemDashboardSla');
          let _filtroDashboardTarefas = this.getStoredItemsByName('listagemDashboardTarefas');
          let _filtroDashboardTecnico = this.getStoredItemsByName('listagemDashboardTecnico');
          let _filtroDashboardVulnerabilidade = this.getStoredItemsByName('listagemDashboardVulnerabilidade');

          // save ticket logs filter
          let _filtroTicketLogs = this.getStoredItemsByName('filtroTicketLogs');

          let _dados_browser = localStorage.getItem('dados_browser');

          let _deviceId = this.getDeviceIdValue();

          let lembrarDispositivo = localStorage.getItem('lembrarDispositivo');

          let fluxo_auth_bc = localStorage.getItem('bc_redirect_auth');

          let _gridOverview = localStorage.getItem('gridoverviewgrid');
          let _gridState = localStorage.getItem('gridState');

          localStorage.clear();

          this.removeStoredItem("stopwatchSoundAlert");
          this.removeStoredItem("stopwatchRefreshDashboard");

          localStorage.setItem('theme', _tema);

          if (fluxo_auth_bc) {
            localStorage.setItem('bc_redirect_auth', fluxo_auth_bc);
          }

          this.setStoredItemsByName('listagemDashboardTicket', _filtroDashboardTicket);
          this.setStoredItemsByName('listagemCanaisAtendimento', _filtroDashboardCanaisAtendimento);
          this.setStoredItemsByName('listagemDashboardChat', _filtroDashboardChat);
          this.setStoredItemsByName('listagemDashboardUsersStatus', _filtroDashboardUsersStatus);
          this.setStoredItemsByName('listagemDashboardClassificacaoInterna', _filtroDashboardClassificacaoInterna);
          this.setStoredItemsByName('listagemDashboardClassificacaoTicketCliente', _filtroDashboardClassificacaoTicketCliente);
          this.setStoredItemsByName('listagemDashboardDashboard', _filtroDashboardDashboard);
          this.setStoredItemsByName('listagemDashboardInventario', _filtroDashboardInventario);
          this.setStoredItemsByName('listagemDashboardMesas', _filtroDashboardMesas);
          this.setStoredItemsByName('listagemDashBoardMonitoramentoLink', _filtroDashboardMonitoramentoLink);
          this.setStoredItemsByName('listagemDashboardPrincipal', _filtroDashboardPrincipal);
          this.setStoredItemsByName('listagemDashboardSla', _filtroDashboardSla);
          this.setStoredItemsByName('listagemDashboardTarefas', _filtroDashboardTarefas);
          this.setStoredItemsByName('listagemDashboardTecnico', _filtroDashboardTecnico);
          this.setStoredItemsByName('listagemDashboardVulnerabilidade', _filtroDashboardVulnerabilidade);
          this.setStoredItemsByName('filtroTicketLogs', _filtroTicketLogs);

          if (environment.allowFiltroNovo && (_usaFiltroNovo !== null && _usaFiltroNovo !== undefined)) {
            localStorage.setItem('usa_filtro_novo', _usaFiltroNovo);
          }
          if (_dados_browser) {
            localStorage.setItem('dados_browser', _dados_browser);
          }
          this.persistDeviceId(_deviceId);
          if (lembrarDispositivo) {
            localStorage.setItem('lembrarDispositivo', lembrarDispositivo);
          }

          if (sessao_expirada) {
            localStorage.setItem('sessao_expirada', sessao_expirada);
          }

          if (_gridOverview) {
            localStorage.setItem('gridoverviewgrid', _gridOverview);
          }
          if (_gridState) {
            localStorage.setItem('gridState', _gridState);
          }

          //limpa localstorage do chat widget
          window.postMessage({ type: "CLEAR_STORAGE" }, '*');

          if (Notification.permission === 'granted' && this.swPush.isEnabled) {
            //tentativa de acabar com o erro de unsubscribe error do sw
            this.swPush.unsubscribe().then(() => {
              setTimeout(() => {
                this.router.navigate(['/login']).then(() => {
                  window.location.reload();
                });
              }, 500);
            }).catch(() => {
              setTimeout(() => {
                this.router.navigate(['/login']).then(() => {
                  window.location.reload();
                });
              }, 500);
            });
          } else {
            setTimeout(() => {
              this.router.navigate(['/login']).then(() => {
                window.location.reload();
              });
            }, 500);
          }
        }, error: (error) => {
          console.error('logout', error);
        }
      });
  }

  getUserSession(): string {
    if (window.localStorage.getItem("JKt6EHYnC") !== null) {
      try {
        let encryptedData = CryptoJS.AES.decrypt(window.localStorage.getItem("JKt6EHYnC"), this.storageKey);
        let decodedUser = JSON.parse(encryptedData.toString(CryptoJS.enc.Utf8));
        return decodedUser['UserSession'] ? decodedUser['UserSession'] : '';
      } catch (e) {
        console.error(e);
        return '';
      }
    }
  }

  getToken(): string {
    if (window.localStorage.getItem("JKt6EHYnC") !== null) {
      try {
        let encryptedData = CryptoJS.AES.decrypt(window.localStorage.getItem("JKt6EHYnC"), this.storageKey);
        let decodedUser = JSON.parse(encryptedData.toString(CryptoJS.enc.Utf8));
        return decodedUser['AccessToken'];
      } catch (e) {
        console.error(e);
        return null;
      }
    }
  }

  private shouldUseDeviceCookie(): boolean {
    return typeof document !== 'undefined' && location.hostname.endsWith(this.deviceCookieDomain);
  }

  private getDeviceIdValue(): string | null {
    if (this.shouldUseDeviceCookie()) {
      return this.getCookie(this.deviceCookieName);
    }

    return window.localStorage.getItem(this.deviceCookieName);
  }

  private persistDeviceId(deviceId: string | null): void {
    if (!deviceId) {
      return;
    }

    if (this.shouldUseDeviceCookie()) {
      this.setCookie(this.deviceCookieName, deviceId, 365, this.deviceCookieDomain);
    } else {
      window.localStorage.setItem(this.deviceCookieName, deviceId);
    }
  }

  private setCookie(name: string, value: string, days: number, domain?: string): void {
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (days * 24 * 60 * 60 * 1000));
    const domainPart = domain ? `;domain=.${domain}` : '';
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expiryDate.toUTCString()};path=/${domainPart}`;
  }

  private getCookie(name: string): string | null {
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (let cookie of cookies) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.indexOf(cookieName) === 0) {
        return trimmedCookie.substring(cookieName.length);
      }
    }

    return null;
  }

  private deleteCookie(name: string, domain?: string): void {
    const domainPart = domain ? `;domain=.${domain}` : '';
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${domainPart}`;
  }
}
